/** @format */

import React, { useState, useEffect } from "react";

const ColumnsInfoTab = ({ csvInfo, target }) => {
  const [newCsvInfo, setNewCsvInfo] = useState([]);
  useEffect(() => {
    if (csvInfo) {
      let tempNewCsvInfo = [];
      for (let i in Object.keys(csvInfo)) {
        tempNewCsvInfo.push({ key: Object.keys(csvInfo)[i], value: Object.values(csvInfo)[i] });
      }
      setNewCsvInfo(tempNewCsvInfo);
    }
  }, [csvInfo]);

  return (
    <div className="w-full  bg-gray-input rounded-xl p-4">
      <div className="flex justify-between items-center">
        <h5 className="text-333 font-bold">컬럼 설명</h5>
      </div>
      <div className="w-full flex">
        <div className="w-full flex items-center mt-2">
          <p className="text-333 font-bold mb-0 mr-6 w-4/12">컬럼명</p>
          <p className="text-333 font-bold mb-0 mr-6 w-2/12">데이터 타입</p>
          <p className="text-333 font-bold mb-0 mr-3 w-6/12">설명</p>
        </div>
      </div>
      {newCsvInfo &&
        newCsvInfo.map((m) => (
          <div className="w-full flex" key={m.key}>
            <div className="w-full flex items-center mt-2">
              <p className="text-333 font-bold mb-0 mr-3 w-4/12">{m.key}</p>
              <div className="mr-3 w-2/12">
                <p className="bg-white rounded-full mb-0 py-1 px-3 mx-2 flex justify-center">{m.value.dataType}</p>
              </div>
              <p className="px-3 py-1 mb-0 rounded-full mr-3 w-6/12">{m.value.info}</p>
            </div>
          </div>
        ))}
      <div className="w-full mt-4">
        <div className="w-full">
          <div className="w-full flex items-center mt-2">
            <p className="text-primary font-bold mb-0 mr-6 w-4/12">타켓 컬럼(결과 컬럼)</p>
            <p className="text-white bg-primary font-bold mb-0 mr-6 w-4/12 flex justify-center py-1 px-2">{target}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColumnsInfoTab;
